import React from 'react';
import ReactDOM from 'react-dom/client';
import '@shopify/polaris/build/esm/styles.css';
import App from './App';

// Make sure we have URL params for App Bridge V4 if needed by the app
const urlParams = new URLSearchParams(globalThis.window?.location.search || '');
const shop = urlParams.get('shop');
const host = urlParams.get('host');
const apiKey = process.env.SHOPIFY_API_KEY || globalThis.window?.SHOPIFY_API_KEY || "";

// Note: App Bridge is loaded via CDN script tag in index.html
// and automatically initialized. Access it via global window.shopify


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


